import PerfectScrollbar from 'react-perfect-scrollbar';
import { FileTreeContents } from './file-tree-contents';

export const FileManagerTreeWindow = ({ rootFolderName, contents, setPath, getImage }) => {

    return (
        <div className="file-manager-sidebar-content">
            <PerfectScrollbar className="h-100 p-3" options={{ suppressScrollX: true }}>
                {/* <input type="text" className="form-control form-control-sm mb-3" placeholder="Search files..." /> //TODO Add back in */}
                <div className="file-tree mb-3">
                    <FileTreeContents
                        rootFolderName={rootFolderName}
                        setPath={setPath}
                        contents={contents}
                        getImage={getImage}
                    />
                </div>
            </PerfectScrollbar>
        </div>
    );
};